// dashboardRoutes - Sprint 50 Fase 1.
// Componente que encapsula las sub-rutas del Dashboard Premium. Se
// monta en AppRoutes.jsx via <Route path="/dashboard/*" element=
// {<DashboardRoutes />} /> dentro de ShellRoutes (inner Routes
// autenticado). Patron identico al resto de modulos XL (couriers,
// productos, etc) salvo que vive en src/routes/ por decision del plan.
//
// Sub-rutas Fase 1:
//   /dashboard            -> DashboardPageXL (activa)
//
// Sub-rutas Fase 2 (reservadas, redirect a /dashboard hasta que se
// implementen):
//   /dashboard/ventas     -> redirect
//   /dashboard/inventario -> redirect
//   /dashboard/alertas    -> redirect
//
// Cuando Fase 2 las implemente, reemplazar Navigate por el componente
// real (sin tocar el resto del file).

import { Routes, Route, Navigate } from 'react-router-dom';

export default function DashboardRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/" replace />} />
      <Route path="ventas" element={<Navigate to=".." replace />} />
      <Route path="inventario" element={<Navigate to=".." replace />} />
      <Route path="alertas" element={<Navigate to=".." replace />} />
    </Routes>
  );
}
